import 'core-js/stable'

import Vue from 'vue'
import Vuelidate from 'vuelidate'
import SponsorForm from '../components/forms/sponsorform'

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.performance = false

Vue.use(Vuelidate)

new Vue({
	el: '#sponsor-form',
	components: {
		SponsorForm
	}
})




// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/sponsorship.js